<!-- Title -->
<div style="padding: 8px 20px; border-bottom: 2px solid rgb(221, 221, 221); background: rgb(230, 0, 126); color: white; font-weight: bold; border-radius: 8px 8px 0 0 ">Anmeldungen pro Rolle</div>

<!-- Canvas -->
<div style="background: white; padding: 20px; border-radius: 0 0 8px 8px">
    <canvas id="line-chart"></canvas>
</div>
